/* Team */
export const GET_TEAM = "GET_TEAM";
export const GET_TEAM_SUCCESS = "GET_TEAM_SUCCESS";
export const GET_TEAM_ERROR = "GET_TEAM_ERROR";

export const GET_TEAMS = "GET_TEAMS";
export const GET_TEAMS_SUCCESS = "GET_TEAMS_SUCCESS";
export const GET_TEAMS_ERROR = "GET_TEAMS_ERROR";

export const ADD_TEAM = "ADD_TEAM";
export const ADD_TEAM_SUCCESS = "ADD_TEAM_SUCCESS";
export const ADD_TEAM_ERROR = "ADD_TEAM_ERROR";

export const MODIFY_TEAM = "MODIFY_TEAM";
export const MODIFY_TEAM_SUCCESS = "MODIFY_TEAM_SUCCESS";
export const MODIFY_TEAM_ERROR = "MODIFY_TEAM_ERROR";

export const DELETE_TEAM = "DELETE_TEAM";
export const DELETE_TEAM_SUCCESS = "DELETE_TEAM_SUCCESS";
export const DELETE_TEAM_ERROR = "DELETE_TEAM_ERROR";

/* Team Users */
export const GET_TEAM_USER = "GET_TEAM_USER";
export const GET_TEAM_USER_SUCCESS = "GET_TEAM_USER_SUCCESS";
export const GET_TEAM_USER_ERROR = "GET_TEAM_USER_ERROR";

export const GET_TEAM_USERS = "GET_TEAM_USERS";
export const GET_TEAM_USERS_SUCCESS = "GET_TEAM_USERS_SUCCESS";
export const GET_TEAM_USERS_ERROR = "GET_TEAM_USERS_ERROR";

export const ADD_TEAM_USER = "ADD_TEAM_USER";
export const ADD_TEAM_USER_SUCCESS = "ADD_TEAM_USER_SUCCESS";
export const ADD_TEAM_USER_ERROR = "ADD_TEAM_USER_ERROR";

export const DELETE_TEAM_USER = "DELETE_TEAM_USER";
export const DELETE_TEAM_USER_SUCCESS = "DELETE_TEAM_USER_SUCCESS";
export const DELETE_TEAM_USER_ERROR = "DELETE_TEAM_USER_ERROR";
